module.exports = {"TXTACL_Decrease":{"id":"TXTACL_Decrease","defaultMessage":"Micşorează"},"TXTACL_Increase":{"id":"TXTACL_Increase","defaultMessage":"Creşte"}}